/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The actually filterable values for a data entry. A many_to_one mapping is necessary to both AnalyticFilterDefinition and analyticValue.
 */
export interface AnalyticFilterData { 
    /**
     * Internal AnalyticFilterData Key
     */
    id?: number;
    /**
     * Internal AnalyticValue Key
     */
    analyticValueId?: number;
    /**
     * Internal AnalyticFilterDefinition Key
     */
    analyticFilterDefinitionId?: number;
    /**
     * Numeric value
     */
    valueNum?: number;
    /**
     * String value
     */
    valueStr?: string;
}

